module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/card-icon1-ea25c979ecbd9f51107c488021873dc4.png";